var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5976 28.1546C24.5257 28.0148 25.3635 27.5342 25.9269 26.8186C26.4902 26.1031 26.7328 25.2111 26.6014 24.3389L19.6029 25.3933C19.7343 26.2655 20.229 27.0464 20.9781 27.5642C21.7273 28.0821 22.6695 28.2945 23.5976 28.1546ZM21.6471 3.39136C21.6371 3.15905 21.5754 2.9322 21.4662 2.72542C21.3569 2.51865 21.2025 2.33655 21.0128 2.19087C20.8231 2.04519 20.6023 1.93915 20.3648 1.87961C20.1273 1.82007 19.8782 1.80834 19.6337 1.84518C19.3892 1.88201 19.1547 1.9666 18.9453 2.09349C18.7358 2.22037 18.5561 2.38673 18.4178 2.58184C18.2794 2.77695 18.1855 2.99648 18.142 3.22626C18.0985 3.45605 18.1064 3.69099 18.1653 3.91594C16.2447 4.5919 14.6188 5.86843 13.5631 7.52938C12.5074 9.19032 12.0866 11.1336 12.3721 13.0302C12.6441 14.8355 12.9837 23.0275 10.6069 25.0671L35.1019 21.3766C32.2297 20.1278 30.1405 12.1995 29.8685 10.3941C29.269 6.415 25.7592 3.54701 21.6471 3.39136Z",
    fill: "#DF2C26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46589 9.03649C6.90501 9.29567 7.05088 9.86175 6.7917 10.3009C5.88024 11.8452 5.14066 15.6082 7.42867 18.9735C7.71537 19.3952 7.60594 19.9694 7.18427 20.2561C6.7626 20.5428 6.18836 20.4334 5.90167 20.0117C3.14702 15.9601 3.9891 11.4165 5.20151 9.36231C5.46069 8.92319 6.02677 8.77732 6.46589 9.03649Z",
    fill: "#DF2C26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0442 4.11557C33.6798 4.47226 33.6736 5.0568 34.0303 5.42118C35.2847 6.7026 36.9029 10.1795 35.4863 13.9944C35.3088 14.4724 35.5524 15.0038 36.0304 15.1813C36.5084 15.3588 37.0398 15.1152 37.2173 14.6372C38.9229 10.0443 37.0184 5.83401 35.3498 4.12949C34.9931 3.76511 34.4086 3.75888 34.0442 4.11557Z",
    fill: "#DF2C26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.21378 7.16547C3.66619 7.40068 3.84226 7.95811 3.60704 8.41052C2.49701 10.5455 1.10113 16.1541 4.5028 21.1922C4.78813 21.6147 4.67686 22.1886 4.25427 22.474C3.83168 22.7593 3.25779 22.648 2.97246 22.2254C-0.934458 16.4391 0.666684 10.063 1.96873 7.55873C2.20395 7.10632 2.76138 6.93025 3.21378 7.16547Z",
    fill: "#DF2C26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7538 1.52169C36.3708 1.85829 36.3332 2.44165 36.6698 2.82466C38.2583 4.63216 40.9553 9.74407 38.8575 15.4495C38.6815 15.9281 38.9268 16.4587 39.4054 16.6347C39.884 16.8106 40.4146 16.5653 40.5906 16.0867C42.9999 9.53386 39.9201 3.72587 38.0568 1.60571C37.7202 1.2227 37.1369 1.18508 36.7538 1.52169Z",
    fill: "#DF2C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/iconBell.92272dab1cf738ed585ce0c21d5ea422.svg";
export { ForwardRef as ReactComponent };